/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TaskInfo,
    TaskInfoFromJSON,
    TaskInfoFromJSONTyped,
    TaskInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface DownloadArchiveUpdate
 */
export interface DownloadArchiveUpdate {
    /**
     * 
     * @type {TaskInfo}
     * @memberof DownloadArchiveUpdate
     */
    taskInfo: TaskInfo;
    /**
     * 
     * @type {string}
     * @memberof DownloadArchiveUpdate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DownloadArchiveUpdate
     */
    path: string;
    /**
     * 
     * @type {number}
     * @memberof DownloadArchiveUpdate
     */
    progressUnit?: DownloadArchiveUpdateProgressUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof DownloadArchiveUpdate
     */
    user?: number | null;
}

/**
* @export
* @enum {string}
*/
export enum DownloadArchiveUpdateProgressUnitEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}

export function DownloadArchiveUpdateFromJSON(json: any): DownloadArchiveUpdate {
    return DownloadArchiveUpdateFromJSONTyped(json, false);
}

export function DownloadArchiveUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DownloadArchiveUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'taskInfo': TaskInfoFromJSON(json['task_info']),
        'name': json['name'],
        'path': json['path'],
        'progressUnit': !exists(json, 'progress_unit') ? undefined : json['progress_unit'],
        'user': !exists(json, 'user') ? undefined : json['user'],
    };
}

export function DownloadArchiveUpdateToJSON(value?: DownloadArchiveUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'task_info': TaskInfoToJSON(value.taskInfo),
        'name': value.name,
        'path': value.path,
        'progress_unit': value.progressUnit,
        'user': value.user,
    };
}


